import { secondAxios } from "../../../../../../../../api/axios";
import { handleComparing } from "./handleComparing";

export const ifSoftwareValidation = async ({
  drawingId,
  setOpenCompare,
  setComparedDrawing,
  showDrawingById,
  setCurrentResponse,
}) => {
  const res = await secondAxios.get("/drawing/get-validation/" + drawingId);
  if (res?.data?.existedDrawing?.id) {
    const { existedDrawing, existedDrawingRevs } = res.data;

    if (existedDrawingRevs?.length === 1) {
      // alert("it's a new drawing !");
      await showDrawingById(drawingId);
      setCurrentResponse({
        state: "success",
        message: "The new Drawing Revision is successfully stored in Database.",
      });
    } else {
      const lastRev = [...existedDrawingRevs]
        .sort((a, b) => a.revision.localeCompare(b.revision))
        .at(-2);

      console.log("existedDrawing", existedDrawing);
      console.log("lastRev", lastRev);

      setOpenCompare(true);
      const comparedDrawingResults = handleComparing({
        selectedDrawings: [
          lastRev,
          { ...existedDrawing, selectedSource: "freecad" },
        ],
        handleCloseCompareModal: () => setOpenCompare(false),
      });
      setComparedDrawing(comparedDrawingResults);
    }
  } else {
    alert(
      "Something went wrong, Please refresh the page and select the drawing."
    );
  }
};
